<template>
  <div class="setCenter pointer">
    <NavBar title="设置"></NavBar>
    <div class="settingBox">
      <div class="setting-item">
        <div class="item" @click="touxiang = true">
          <div class="item_left">
            <p class="p1">头像</p>
          </div>
          <div class="item_right">
            <img
              class="avatar"
              :src="
                token
                  ? userinfo.avatar
                    ? userinfo.avatar
                    : require('@/assets/icons/defaultAvatar.png')
                  : require('@/assets/icons/defaultAvatar.png')
              "
              alt=""
            />
          </div>
        </div>
        <div class="item">
          <div class="item_left">
            <p class="p1">ID</p>
          </div>
          <div class="item_right" @click="issucopy">
            <div>{{ token ? userinfo.id : "" }}</div>
            <img
              class="copyIcon"
              v-if="token"
              src="@/assets/icons/copy.png"
              alt=""
            />
          </div>
        </div>
        <div class="item">
          <div class="item_left">
            <p class="p1">手机号</p>
          </div>
          <div class="item_right">
            <p class="p1">{{ token ? userinfo.phoneNumber : "" }}</p>
          </div>
        </div>
      </div>
      <div class="setting-item">
        <div class="item" @click="toSetPassword">
          <div class="item_left">
            <img class="ico" src="@/assets/icons/changePassword.png" alt="" />
            <p class="p1">修改密码</p>
          </div>
          <div class="item-r">
            <div class="arrow"></div>
          </div>
        </div>
      </div>
    </div>
    <van-popup
      round
      class="toux_pop pcPopup"
      v-model="touxiang"
      position="bottom"
    >
      <van-uploader
        class="paizhao"
        :before-read="beforeRead"
        capture="camera"
        accept="image/*"
        :after-read="afterRade"
      >
        <div class="xiangce">拍照</div>
      </van-uploader>
      <van-uploader
        :before-read="beforeRead"
        :after-read="afterRade"
        accept=".png, .jpg, .jpeg"
      >
        <div class="xiangce">从相册中选择</div>
      </van-uploader>
      <div class="quxiao" @click="touxiang = false">取消</div>
    </van-popup>
  </div>
</template>
          <script>
import NavBar from "@/components/NavBar.vue";
import { uploadgetSts } from "@/api/index.js";
import { usercheckpassword } from "@/api/login";
import { update } from "@/api/index.js";
import OSS from "ali-oss";
import { setData } from "@/utils/auth";
import { mapMutations } from "vuex";
import { Toast } from "vant";
export default {
  name: "SetCenter",
  components: {
    NavBar,
  },
  data() {
    return {
      userinfo: JSON.parse(this.$store.getters.data),
      token: this.$store.getters.token,
      touxiang: false,
    };
  },
  mounted() {},
  methods: {
    ...mapMutations("user", ["SET_DATA"]),
    // 复制
    issucopy() {
      this.$common.copy(this.userinfo.id, "复制成功!");
    },
    toSetPassword() {
      usercheckpassword().then((res) => {
        if (res.code == 200) {
          this.$router.push({
            path: "/setPassword",
            query: {
              phone: this.userinfo.phoneNumber,
              title: res.data ? "修改密码" : "设置密码",
            },
          });
        }
      });
    },
    // 获取当前时间
    getCurrentDateTime() {
      // 获取当前时间
      let currentTime = new Date();
      // 获取日期部分
      let year = currentTime.getFullYear();
      let month = (currentTime.getMonth() + 1).toString().padStart(2, "0");
      let day = currentTime.getDate().toString().padStart(2, "0");
      // 获取时间部分
      let hours = currentTime.getHours().toString().padStart(2, "0");
      let minutes = currentTime.getMinutes().toString().padStart(2, "0");
      let seconds = currentTime.getSeconds().toString().padStart(2, "0");
      // 组合成完整的时间格式
      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    },
    //上传文件的前置校验，可以在里面写自己的规则，如：格式、大小等
    beforeRead(file) {
      if (file.type.indexOf("image") == -1) {
        Toast("请上传正确格式图片");
        return false;
      }
      return true;
    },
    //上传完成后的回调函数，此时可以上传到阿里云
    async afterRade(file) {
      await uploadgetSts().then((res) => {
        if (res.code == 200) {
          this.uploadinfo = res.data;
        }
      });
      let that = this;
      let data = {
        accessKeyId: that.uploadinfo.accessKeyId,
        accessKeySecret: that.uploadinfo.accessKeySecret,
        stsToken: that.uploadinfo.securityToken,
        region: "oss-cn-shenzhen",
        bucket: that.uploadinfo.bucket,
      };
      let client = new OSS(data);
      const fileN = file.content;
      const base64 = fileN.split(",").pop();
      const fileType = fileN.split(";").shift().split(":").pop();
      const blob = that.toBlob(base64, fileType);
      that.readFile(blob).then((res) => {
        const objectKey =
          "files/image/" + that.getCurrentDateTime() + "/" + that.userinfo.uuid;
        const buffer = new OSS.Buffer(res.target.result);
        client
          .put(objectKey, buffer)
          .then((result) => {
            that.userinfo.avatar = result.url;
            that.postupdate();
          })
          .catch((err) => {
            console.log(err);
          });
      });
    },
    readFile(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsArrayBuffer(file);
        reader.onload = function (event) {
          resolve(event);
        };
      });
    },
    //转bolb对象
    toBlob(urlData, fileType) {
      let bytes = window.atob(urlData);
      let n = bytes.length;
      let u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bytes.charCodeAt(n);
      }
      return new Blob([u8arr], { type: fileType });
    },
    // 修改用户信息
    postupdate() {
      let that = this;
      update({ avatar: that.userinfo.avatar }).then((res) => {
        if (res.code == 200) {
          Toast("上传图片成功！");
          that.touxiang = false;
          setData(that.userinfo);
          that.SET_DATA(JSON.stringify(that.userinfo));
        }
      });
    },
  },
};
</script>
          
      <style lang="less" scoped>
.setCenter {
  .settingBox {
    padding: 10px 16px;
    .setting-item {
      width: 100%;
      background: #fff;
      border-radius: 10px;
      color: #333;
      font-size: 14px;
      padding: 0 16px;
      margin-bottom: 12px;

      .item {
        width: 100%;
        height: 56px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        .item_left {
          display: flex;
          align-items: center;
          .ico {
            width: 16px;
            height: 16px;
            margin-right: 12px;
          }
        }
        .item_right {
          display: flex;
          color: #999;
          .avatar {
            width: 40px;
            height: 40px;
            border-radius: 40px;
          }
          .copyIcon {
            width: 16px;
            height: 16px;
            margin-left: 6px;
          }
        }
        .item-r {
          color: #999;
          .arrow {
            border-color: #999;
            height: 6px;
            margin-left: 3px;
            margin-right: 2px;
            width: 6px;
            display: inline-block;
            position: relative;
          }
          .arrow:after {
            background-color: inherit;
            border-color: inherit;
            border-style: solid;
            content: "";
            height: inherit;
            left: 0;
            position: absolute;
            top: 0;
            transition: all 0.3s ease;
            width: inherit;
            border-width: 0 0 1px 1px;
            transform: rotate(-135deg);
          }
        }
      }
      .item:not(:last-child) {
        border-bottom: 1px solid #e6e6e6;
      }
    }
  }
}
.toux_pop {
  div {
    width: 100%;
    height: 50px;
    line-height: 50px;
    font-size: 14px;
  }
  .paizhao {
    margin-top: 16px;
  }
  .video {
    display: none;
  }
  /deep/.van-uploader__input-wrapper {
    width: 100%;
  }
}
</style>